import React from 'react';
import {createRoot} from 'react-dom/client';
import {store} from "@redux/store";
import { Provider } from 'react-redux';
import {App} from "@components/App";

if ("serviceWorker" in navigator && location.hostname !== "localhost") {
    navigator.serviceWorker.register("/sw.js");
}

const rootElement = document.getElementById("root");

if (rootElement) {
    const root = createRoot(rootElement);

    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <App/>
            </Provider>
        </React.StrictMode>
    );
}
